document.documentElement.classList.remove('no-js');

(() => {
  const DESIGN_MODE = !!(window.Shopify && Shopify.designMode) || document.body?.dataset.designMode === 'true';
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  const header = qs('[data-site-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
  updateHeader();
  addEventListener('scroll', updateHeader, { passive: true });

  const menuToggle = qs('[data-menu-toggle]');
  const mobileMenu = qs('[data-mobile-menu]');
  menuToggle?.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!open));
    mobileMenu?.classList.toggle('is-open', !open);
    document.body.classList.toggle('menu-open', !open);
  });

  const searchDialog = qs('[data-search-dialog]');
  qsa('[data-search-open]').forEach(btn => btn.addEventListener('click', () => {
    if (!searchDialog) return;
    searchDialog.showModal();
    setTimeout(() => qs('input[type="search"]', searchDialog)?.focus(), 50);
  }));
  qs('[data-search-close]')?.addEventListener('click', () => searchDialog?.close());
  searchDialog?.addEventListener('click', e => { if (e.target === searchDialog) searchDialog.close(); });

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
  }, { threshold: .12, rootMargin: '0px 0px -6% 0px' }) : null;
  qsa('[data-reveal]').forEach(el => observer ? observer.observe(el) : el.classList.add('is-visible'));

  qsa('.magnetic').forEach(btn => {
    btn.addEventListener('pointermove', e => {
      if (matchMedia('(pointer: coarse)').matches) return;
      const r = btn.getBoundingClientRect();
      btn.style.transform = `translate(${(e.clientX-r.left-r.width/2)*.08}px, ${(e.clientY-r.top-r.height/2)*.08}px)`;
    });
    btn.addEventListener('pointerleave', () => btn.style.transform = '');
  });

  qsa('[data-qty-minus]').forEach(btn => btn.addEventListener('click', () => { const i = btn.parentElement.querySelector('input'); i.value = Math.max(1, Number(i.value || 1) - 1); }));
  qsa('[data-qty-plus]').forEach(btn => btn.addEventListener('click', () => { const i = btn.parentElement.querySelector('input'); i.value = Number(i.value || 1) + 1; }));

  qsa('[data-product-section]').forEach(section => {
    const form = qs('[data-product-form]', section);
    const variantsEl = qs('[data-product-variants]', section);
    if (!form || !variantsEl) return;
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch(e) { return; }
    const selects = qsa('[data-option-index]', form);
    const idInput = qs('[data-variant-id]', form);
    const price = qs('[data-product-price] strong', section);
    const compare = qs('[data-product-price] s', section);
    const add = qs('[data-add-to-cart]', form);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style:'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents/100);
    const sync = () => {
      const selected = selects.map(s => s.value);
      const variant = variants.find(v => v.options.every((o,i) => o === selected[i])) || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) { compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : ''; compare.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price; }
      if (add) { add.disabled = !variant.available; add.querySelector('span').textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft'; }
      if (!DESIGN_MODE && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u); }
    };
    selects.forEach(s => s.addEventListener('change', sync));
  });

  qsa('[data-product-gallery]').forEach(gallery => {
    const panels = qsa('[data-media-id]', gallery);
    const thumbs = qsa('[data-media-target]', gallery);
    thumbs.forEach(btn => btn.addEventListener('click', () => {
      const id = btn.dataset.mediaTarget;
      panels.forEach(p => p.classList.toggle('is-active', p.dataset.mediaId === id));
      thumbs.forEach(t => {
        const active = t === btn;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      btn.scrollIntoView?.({behavior:'smooth', block:'nearest', inline:'center'});
    }));
  });

  const lightbox = qs('[data-lightbox-dialog]');
  const lightboxImage = qs('[data-lightbox-image]', lightbox || document);
  const lightboxCaption = qs('[data-lightbox-caption]', lightbox || document);
  let lightboxItems = [];
  let lightboxIndex = 0;
  const refreshLightboxItems = () => lightboxItems = qsa('.lightbox-trigger:not([tabindex="-1"])');
  const showLightboxItem = idx => {
    refreshLightboxItems();
    if (!lightboxItems.length || !lightbox) return;
    lightboxIndex = (idx + lightboxItems.length) % lightboxItems.length;
    const trigger = lightboxItems[lightboxIndex];
    const src = trigger.dataset.lightboxSrc;
    if (!src) return;
    lightboxImage.src = src;
    lightboxImage.alt = trigger.dataset.lightboxCaption || '';
    lightboxCaption.textContent = trigger.dataset.lightboxCaption || '';
    if (!lightbox.open) lightbox.showModal();
  };
  document.addEventListener('click', e => {
    const trigger = e.target.closest('.lightbox-trigger');
    if (!trigger || trigger.tabIndex === -1) return;
    refreshLightboxItems();
    showLightboxItem(lightboxItems.indexOf(trigger));
  });
  qs('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
  qs('[data-lightbox-prev]')?.addEventListener('click', () => showLightboxItem(lightboxIndex - 1));
  qs('[data-lightbox-next]')?.addEventListener('click', () => showLightboxItem(lightboxIndex + 1));
  lightbox?.addEventListener('click', e => { if (e.target === lightbox) lightbox.close(); });
  addEventListener('keydown', e => { if (!lightbox?.open) return; if (e.key === 'ArrowLeft') showLightboxItem(lightboxIndex - 1); if (e.key === 'ArrowRight') showLightboxItem(lightboxIndex + 1); });

  let touchX = null;
  lightbox?.addEventListener('touchstart', e => touchX = e.changedTouches[0].clientX, {passive:true});
  lightbox?.addEventListener('touchend', e => { if (touchX == null) return; const d=e.changedTouches[0].clientX-touchX; if (Math.abs(d)>50) showLightboxItem(lightboxIndex+(d<0?1:-1)); touchX=null; }, {passive:true});


  // Consent UI backed by Shopify's Customer Privacy API. The theme does not
  // write Shopify consent cookies directly and does not load Google Analytics itself.
  const privacyBanner = qs('[data-privacy-banner]');
  const privacyBasic = qs('[data-privacy-basic]', privacyBanner || document);
  const privacyPreferences = qs('[data-privacy-preferences]', privacyBanner || document);
  let customerPrivacy = null;

  const fillPrivacyInputs = () => {
    if (!customerPrivacy || !privacyBanner) return;
    const current = customerPrivacy.currentVisitorConsent?.() || {};
    const set = (selector, key) => {
      const input = qs(selector, privacyBanner);
      if (input) input.checked = current[key] === 'yes';
    };
    set('[data-consent-preferences]', 'preferences');
    set('[data-consent-analytics]', 'analytics');
    set('[data-consent-marketing]', 'marketing');
  };
  const openPrivacy = (preferences = false) => {
    if (!privacyBanner) return;
    fillPrivacyInputs();
    privacyBanner.hidden = false;
    document.body.classList.add('privacy-open');
    if (privacyBasic) privacyBasic.hidden = preferences;
    if (privacyPreferences) privacyPreferences.hidden = !preferences;
  };
  const closePrivacy = () => {
    if (!privacyBanner) return;
    privacyBanner.hidden = true;
    document.body.classList.remove('privacy-open');
  };
  const setConsent = payload => {
    if (!customerPrivacy?.setTrackingConsent) return;
    customerPrivacy.setTrackingConsent(payload, closePrivacy);
  };
  const initPrivacy = () => {
    if (!privacyBanner || !window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (error) return;
      customerPrivacy = window.Shopify.customerPrivacy;
      if (!customerPrivacy) return;
      fillPrivacyInputs();
      if (customerPrivacy.shouldShowBanner?.()) openPrivacy(false);
    });
  };
  if (!DESIGN_MODE) initPrivacy();
  qsa('[data-privacy-open]').forEach(btn => btn.addEventListener('click', () => openPrivacy(true)));
  qs('[data-consent-settings]', privacyBanner || document)?.addEventListener('click', () => openPrivacy(true));
  qs('[data-consent-back]', privacyBanner || document)?.addEventListener('click', () => openPrivacy(false));
  qs('[data-consent-essential]', privacyBanner || document)?.addEventListener('click', () => setConsent({ analytics:false, marketing:false, preferences:false }));
  qs('[data-consent-all]', privacyBanner || document)?.addEventListener('click', () => setConsent({ analytics:true, marketing:true, preferences:true }));
  qs('[data-consent-save]', privacyBanner || document)?.addEventListener('click', () => setConsent({
    analytics: !!qs('[data-consent-analytics]', privacyBanner)?.checked,
    marketing: !!qs('[data-consent-marketing]', privacyBanner)?.checked,
    preferences: !!qs('[data-consent-preferences]', privacyBanner)?.checked
  }));
})();

// v1.2 predictive search, withdrawal confirmation, optional review feed
(() => {
  const DESIGN_MODE = !!(window.Shopify && Shopify.designMode) || document.body?.dataset.designMode === 'true';
  const debounce=(fn,wait=180)=>{let t;return(...args)=>{clearTimeout(t);t=setTimeout(()=>fn(...args),wait)}};
  const currency=document.body?.dataset.currency||'EUR';
  const money=value=>{const n=Number(value);if(Number.isNaN(n))return '';try{return new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency}).format(n)}catch{return `${n.toFixed(2)} ${currency}`}};
  if (!DESIGN_MODE) document.querySelectorAll('[data-predictive-form]').forEach(form=>{
    const input=form.querySelector('[data-predictive-input]');
    const box=form.querySelector('[data-predictive-results]');
    if(!input||!box)return;
    let controller;
    const render=data=>{
      const results=data?.resources?.results||{};
      const products=(results.products||[]).slice(0,6);
      const collections=(results.collections||[]).slice(0,3);
      if(!products.length&&!collections.length){box.innerHTML='<p class="predictive-empty">Keine direkten Treffer. Suche öffnen, um alle Ergebnisse zu sehen.</p>';box.hidden=false;input.setAttribute('aria-expanded','true');return;}
      const productHTML=products.map(p=>`<a class="predictive-product" href="${p.url}">${p.image?.url?`<img src="${p.image.url}&width=160" alt="">`:''}<span><strong>${p.title}</strong>${p.vendor?`<small>${p.vendor}</small>`:''}<b>${p.price?money(p.price):''}</b></span></a>`).join('');
      const collectionHTML=collections.length?`<div class="predictive-collections"><span>Welten</span>${collections.map(c=>`<a href="${c.url}">${c.title}</a>`).join('')}</div>`:'';
      box.innerHTML=`${productHTML?`<div class="predictive-products">${productHTML}</div>`:''}${collectionHTML}<a class="predictive-all" href="${form.action}?q=${encodeURIComponent(input.value.trim())}">Alle Suchergebnisse anzeigen →</a>`;
      box.hidden=false;input.setAttribute('aria-expanded','true');
    };
    const search=debounce(async()=>{
      const q=input.value.trim();
      if(q.length<2){box.hidden=true;input.setAttribute('aria-expanded','false');return;}
      controller?.abort();controller=new AbortController();
      try{
        const root=(document.body.dataset.rootUrl||'/').replace(/\/$/,'');
        const url=`${root}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
        const r=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});if(!r.ok)throw new Error(r.status);
        render(await r.json());
      }catch(e){if(e.name!=='AbortError')box.hidden=true;}
    },180);
    input.addEventListener('input',search);
    input.addEventListener('focus',()=>{if(input.value.trim().length>=2)search()});
    form.addEventListener('keydown',e=>{if(e.key==='Escape'){box.hidden=true;input.setAttribute('aria-expanded','false')}});
  });

  document.querySelectorAll('[data-withdrawal-form]').forEach(form=>{
    const one=form.querySelector('[data-withdrawal-step="1"]'),two=form.querySelector('[data-withdrawal-step="2"]');
    const summary=form.querySelector('[data-withdrawal-summary]');
    form.querySelector('[data-withdrawal-next]')?.addEventListener('click',()=>{
      const required=[...one.querySelectorAll('[required]')];
      if(required.some(el=>!el.reportValidity()))return;
      const fields=[...one.querySelectorAll('input:not([type="hidden"]),textarea')].map(el=>`<div><span>${el.closest('label')?.childNodes[0]?.textContent?.trim()||el.name}</span><strong>${el.value.replace(/[<>]/g,'')}</strong></div>`).join('');
      summary.innerHTML=fields;one.hidden=true;two.hidden=false;two.scrollIntoView({behavior:'smooth',block:'center'});
    });
    form.querySelector('[data-withdrawal-back]')?.addEventListener('click',()=>{two.hidden=true;one.hidden=false;});
  });

  // eBay reputation feed. The storefront only reads a public, privacy-safe JSON
  // snapshot from app.nerdyvana.de. No eBay HTML is scraped in the browser.
  if (!DESIGN_MODE) document.querySelectorAll('[data-ebay-trust][data-live-feed]').forEach(section=>{
    const url=section.dataset.liveFeed?.trim();
    if(!url)return;
    const cacheKey='nv:ebay-feedback:v1';
    const liveState=section.querySelector('[data-ebay-live-state]');
    const liveLabel=section.querySelector('[data-ebay-live-label]');
    const updated=section.querySelector('[data-ebay-updated]');
    const track=section.querySelector('[data-review-track]');
    const escapeHTML=value=>String(value??'').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
    const formatScore=(value,suffix=' / 5')=>{
      if(value===null||value===undefined||value==='')return '';
      if(typeof value==='number')return `${value.toLocaleString('de-DE',{minimumFractionDigits:1,maximumFractionDigits:1})}${suffix}`;
      return String(value);
    };
    const apply=data=>{
      if(!data||typeof data!=='object')return false;
      const map={
        positive:data.positive ?? (typeof data.positive_percent==='number'?`${String(data.positive_percent).replace('.',',')}%`:data.positive_percent),
        description:data.description_score ?? data.ratings?.description,
        shipping:data.shipping_score ?? data.ratings?.shipping_cost,
        delivery:data.delivery_score ?? data.ratings?.shipping_time ?? data.ratings?.delivery,
        communication:data.communication_score ?? data.ratings?.communication
      };
      Object.entries(map).forEach(([key,value])=>{
        const el=section.querySelector(`[data-ebay-score="${key}"]`);
        if(!el||value===null||value===undefined||value==='')return;
        el.textContent=key==='positive' ? (String(value).includes('%')?String(value):`${value}%`) : formatScore(value);
      });
      const reviews=Array.isArray(data.reviews)?data.reviews.filter(r=>r && (r.quote||r.text||r.comment)).slice(0,16):[];
      if(track&&reviews.length){
        const cards=reviews.map(r=>{
          const quote=escapeHTML(r.quote||r.text||r.comment);
          const date=r.date||r.entered_at||r.feedback_entered_date;
          let footer='eBay-Käufer · bestätigter Kauf';
          if(date){try{footer=`eBay-Käufer · ${new Intl.DateTimeFormat('de-DE',{day:'2-digit',month:'2-digit',year:'numeric'}).format(new Date(date))}`;}catch(e){}}
          return `<blockquote class="review-card"><div class="review-stars" aria-label="5 von 5 Sternen">★★★★★</div><p>„${quote}“</p><footer>${escapeHTML(footer)}</footer></blockquote>`;
        }).join('');
        track.innerHTML=`<div class="review-marquee__group">${cards}</div><div class="review-marquee__group" aria-hidden="true">${cards}</div>`;
      }
      const when=data.updated_at||data.synced_at||data.generated_at;
      if(updated&&when){try{updated.textContent=new Intl.DateTimeFormat('de-DE',{dateStyle:'medium',timeStyle:'short'}).format(new Date(when));}catch(e){updated.textContent=String(when)}}
      if(liveState)liveState.dataset.state='live';
      if(liveLabel)liveLabel.textContent='LIVE · automatisch aus dem Kontrollzentrum';
      return true;
    };
    try{
      const cached=JSON.parse(localStorage.getItem(cacheKey)||'null');
      if(cached?.data)apply(cached.data);
    }catch(e){}
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),4500);
    fetch(url,{headers:{Accept:'application/json'},signal:controller.signal,cache:'no-store'})
      .then(r=>r.ok?r.json():Promise.reject(new Error(`HTTP ${r.status}`)))
      .then(data=>{
        if(apply(data))try{localStorage.setItem(cacheKey,JSON.stringify({savedAt:Date.now(),data}));}catch(e){}
      })
      .catch(()=>{
        if(liveState&&liveState.dataset.state!=='live')liveState.dataset.state='standby';
        if(liveLabel&&liveState?.dataset.state!=='live')liveLabel.textContent='eBay-Reputation · Fallback aktiv';
      })
      .finally(()=>clearTimeout(timer));
  });

  if (!DESIGN_MODE) document.querySelectorAll('[data-product-recommendations]').forEach(section=>{
    if(section.dataset.loaded==='1' || !section.dataset.url) return;
    const load=()=>{
      section.dataset.loaded='1';
      fetch(section.dataset.url,{headers:{Accept:'text/html'}})
        .then(r=>r.ok?r.text():Promise.reject(r.status))
        .then(html=>{
          const doc=new DOMParser().parseFromString(html,'text/html');
          const fresh=doc.querySelector('[data-product-recommendations]');
          if(fresh && fresh.innerHTML.trim()) section.innerHTML=fresh.innerHTML;
        }).catch(()=>{});
    };
    if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>{if(entries[0]?.isIntersecting){io.disconnect();load();}},{rootMargin:'300px'});
      io.observe(section);
    }else load();
  });
})();
